export default "__VITE_ASSET__Dwcs_0Pw__"